import { ChangeEvent } from "react";
import SubmitSkeleton from "../SubmitSkeleton";
import { useCaseContext } from "../../../context/CaseContext";
import CustomLabel from "../../common/CustomLabel";
import LoadingAnimation from "../../common/LoadingAnimation";

const SupportServicesStage = ({
  loading,
  setStep,
  onSubmit,
}: {
  loading: boolean;
  setStep: (step: number) => void;
  onSubmit: () => void;
}) => {
  const { supportServices, hasAbuserInfo, abuserDetails, updateCaseData } =
    useCaseContext();

  const handlePrev = () => {
    if (hasAbuserInfo) {
      if (abuserDetails?.hasAbuserVehicleInfo) {
        setStep(9); // Abuser Vehicle Info
      } else {
        setStep(8); // Abuser Details
      }
    } else {
      setStep(7); // Reporter Details
    }
  };

  const handleSupportServiceChange = (
    e: ChangeEvent<HTMLInputElement>,
    field: "NeedAnAttorney" | "NeedCounseling" | "NeedPrivateInvestigator"
  ) => {
    const { value } = e.target;

    // Convert string value to boolean
    const boolValue = value === "yes" ? true : value === "no" ? false : null;

    updateCaseData("supportServices", {
      ...supportServices,
      [field]: boolValue,
    });
  };

  return (
    <SubmitSkeleton
      onPrev={handlePrev}
      onNext={onSubmit}
      nextBtnText={
        loading ? <LoadingAnimation loadingText="Submitting" /> : "Submit"
      }
      progress={10 / 10}
    >
      <div className="flex flex-col gap-4">
        <CustomLabel labelText="Do you need an attorney?" isRequired>
          <div className="flex flex-col">
            <label className="flex items-center gap-3 pr-6 pl-3 cursor-pointer">
              <input
                type="radio"
                name="NeedAnAttorney"
                value="yes"
                checked={supportServices?.NeedAnAttorney === true}
                onChange={(e) =>
                  handleSupportServiceChange(e, "NeedAnAttorney")
                }
                className="form-radio"
              />
              <span className="font-medium text-base leading-4 text-black py-[14px]">
                Yes
              </span>
            </label>

            <label className="flex items-center gap-3 pr-6 pl-3 cursor-pointer">
              <input
                type="radio"
                name="NeedAnAttorney"
                value="no"
                checked={supportServices?.NeedAnAttorney === false}
                onChange={(e) =>
                  handleSupportServiceChange(e, "NeedAnAttorney")
                }
                className="form-radio"
              />
              <span className="font-medium text-base leading-4 text-black py-[14px]">
                No
              </span>
            </label>

            {/* <label className="flex items-center gap-3 pr-6 pl-3 cursor-pointer">
              <input
                type="radio"
                name="NeedAnAttorney"
                value="unsure"
                checked={supportServices?.NeedAnAttorney === null}
                onChange={(e) =>
                  handleSupportServiceChange(e, "NeedAnAttorney")
                }
                className="form-radio"
              />
              <span className="font-medium text-base leading-4 text-black py-[14px]">
                Unsure
              </span>
            </label> */}
          </div>
        </CustomLabel>

        <CustomLabel labelText="Do you need counseling?" isRequired>
          <div className="flex flex-col">
            <label className="flex items-center gap-3 pr-6 pl-3 cursor-pointer">
              <input
                type="radio"
                name="NeedCounseling"
                value="yes"
                checked={supportServices?.NeedCounseling === true}
                onChange={(e) =>
                  handleSupportServiceChange(e, "NeedCounseling")
                }
                className="form-radio"
              />
              <span className="font-medium text-base leading-4 text-black py-[14px]">
                Yes
              </span>
            </label>

            <label className="flex items-center gap-3 pr-6 pl-3 cursor-pointer">
              <input
                type="radio"
                name="NeedCounseling"
                value="no"
                checked={supportServices?.NeedCounseling === false}
                onChange={(e) =>
                  handleSupportServiceChange(e, "NeedCounseling")
                }
                className="form-radio"
              />
              <span className="font-medium text-base leading-4 text-black py-[14px]">
                No
              </span>
            </label>

            {/* <label className="flex items-center gap-3 pr-6 pl-3 cursor-pointer">
              <input
                type="radio"
                name="NeedCounseling"
                value="unsure"
                checked={supportServices?.NeedCounseling === null}
                onChange={(e) =>
                  handleSupportServiceChange(e, "NeedCounseling")
                }
                className="form-radio"
              />
              <span className="font-medium text-base leading-4 text-black py-[14px]">
                Unsure
              </span>
            </label> */}
          </div>
        </CustomLabel>

        <CustomLabel
          labelText="Do you want to hire a private investigator?"
          isRequired
        >
          <div className="flex flex-col">
            <label className="flex items-center gap-3 pr-6 pl-3 cursor-pointer">
              <input
                type="radio"
                name="NeedPrivateInvestigator"
                value="yes"
                checked={supportServices?.NeedPrivateInvestigator === true}
                onChange={(e) =>
                  handleSupportServiceChange(e, "NeedPrivateInvestigator")
                }
                className="form-radio"
              />
              <span className="font-medium text-base leading-4 text-black py-[14px]">
                Yes
              </span>
            </label>

            <label className="flex items-center gap-3 pr-6 pl-3 cursor-pointer">
              <input
                type="radio"
                name="NeedPrivateInvestigator"
                value="no"
                checked={supportServices?.NeedPrivateInvestigator === false}
                onChange={(e) =>
                  handleSupportServiceChange(e, "NeedPrivateInvestigator")
                }
                className="form-radio"
              />
              <span className="font-medium text-base leading-4 text-black py-[14px]">
                No
              </span>
            </label>

            {/* <label className="flex items-center gap-3 pr-6 pl-3 cursor-pointer">
              <input
                type="radio"
                name="NeedPrivateInvestigator"
                value="unsure"
                checked={supportServices?.NeedPrivateInvestigator === null}
                onChange={(e) =>
                  handleSupportServiceChange(e, "NeedPrivateInvestigator")
                }
                className="form-radio"
              />
              <span className="font-medium text-base leading-4 text-black py-[14px]">
                Unsure
              </span>
            </label> */}
          </div>
        </CustomLabel>
      </div>
    </SubmitSkeleton>
  );
};

export default SupportServicesStage;
